<template>
  <div>

      <Tablelist
              :showCheckbox="false"
              :list="list"
              :columns="tableColumns"></Tablelist>


    <div style="padding-top: 8px;color: #999;font-size: .8em">
      <div>60分以下差，60-80分一般，80-90分良好，90-100分优秀。</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          align: "center",
          scopedSlots: { customRender: "key" },
        },

        {
          title: "姓名",
          dataIndex: "userName",
          align: "center",
          scopedSlots: { customRender: "userName" },
        },
        {
          title: "指派任务数量",
          dataIndex: "taskNumPlan",
          align: "center",
          scopedSlots: { customRender: "taskNumPlan" },
        },
        {
          title: "实际完成数量",
          dataIndex: "taskNumDone",
          align: "center",
          scopedSlots: { customRender: "taskNumDone" },
        },

        {
          title: "任务完成率",
          dataIndex: "completeRatio",
          align: "center",
          scopedSlots: { customRender: "completeRatio" },
        },
        {
          title: "平均得分",
          dataIndex: "average",
          align: "center",
          scopedSlots: { customRender: "average" },
        },
        {
          title: "actions",
          dataIndex: "appraisal",
          align: "center",
          scopedSlots: { customRender: "appraisal" },
        },
      ],


        tableColumns: [
            {
                key: 'key',
                title: '序号',
                field: 'key',
                infotype: 'text'
            },
            {
                key: 'userName',
                title: '姓名',
                field: 'userName',
                infotype: 'text',
            },
            {
                key: 'taskNumPlan',
                title: '指派任务数量',
                field: 'timeEnd',
                infotype: 'text',
            },
            {
                key: 'assessNum',
                title: '任务完成率',
                field: 'assessNum',
                infotype: 'text',
            },
            {
                key: 'status',
                title: '平均得分',
                field: 'status',
                infotype: 'dictType',
                dictType:'assessPlanStatus'
            },
            {
                key: 'actions',
                title: '任务完成率',
                field: 'actions',
                infotype: 'text',
            }
        ],
      assessList: [
        {
          value: "优秀",
          userName: "优秀",
        },
        {
          value: "良好",
          userName: "良好",
        },
        {
          value: "一般",
          userName: "一般",
        },
        {
          value: "差",
          userName: "差",
        },
      ],
    };
  },

  methods: {
    assessChange(val, record) {
      record.appraisal = val;
      this.$emit("change", this.list);
    },
  },
};
</script>
